import { ClassGroupModel, ClassModelSchedules, StudentGroupModel } from "@/models";
import { ResourceModel } from "@/models/resource.model";
import { AdminService } from "../admin.service";
import { TeacherServiceInterface } from "./interface";
import {
  AccessibleSchoolQueryParam,
  ClassLessonPlanDto,
  FetchStudentsByGroupIdReqModel,
  FetchStudentsByGroupIdResModel,
  ScheduleParam,
  SkipScheduleResponse,
} from "./model";
class GLTeacherService extends AdminService implements TeacherServiceInterface {
  getAccessibleSchools(params: AccessibleSchoolQueryParam): Promise<ResourceModel[]> {
    return this.get("schools/accessibleschools", params);
  }
  getScheduleCalendar(schoolId: string, classId: string, groupId: string, startDate: string, endDate: string): Promise<any> {
    let url = `schedule/${schoolId}/${startDate}`;
    if (!schoolId) {
      url = `schedule/${startDate}`;
    }
    return this.get(url, {
      endDate: endDate,
      classId: classId,
      groupId: groupId,
      includeSkip: true,
    });
  }
  createSchedule(params: ScheduleParam): Promise<any> {
    const url = `schedule/create`;
    return this.create(url, params);
  }
  updateSchedule(params: ScheduleParam): Promise<any> {
    const url = `schedule/update`;
    return this.create(url, params);
  }
  deleteSchedule(scheduleId: string) {
    return this.delete(`schedule/delete/${scheduleId}`);
  }
  skipSchedule(params: ScheduleParam): Promise<SkipScheduleResponse> {
    return this.create(`schedule/skip`, params);
  }
  getAllClassesSchedule(schoolId: string): Promise<Array<ClassModelSchedules>> {
    const url = `schoolclass/${schoolId}`;
    return this.get(url);
  }
  getGroupStudents(classId: string, groupId: string): Promise<Array<StudentGroupModel>> {
    const url = `${classId}/groups/${groupId}/students`;
    return this.get(url);
  }
  getAllClassesOfAllSchools(regionId = "", schoolId = "", campusId = ""): Promise<Array<ClassModelSchedules>> {
    const url = `schoolclass/teacher-dashboard`;
    return this.get(url, {
      regionId,
      schoolId,
      campusId,
      __gl_region__: regionId || "",
    });
  }
  getClassGroup(): Promise<Array<ClassGroupModel>> {
    const url = "schoolclass/class-group";
    return this.get(url);
  }
  getAllScheduleCalendar(startDate: string, endDate: string): Promise<any> {
    const url = `schedule/${startDate}`;
    return this.get(url, { endDate, includeSkip: true });
  }
  fetchStudentsByGroupId(params: FetchStudentsByGroupIdReqModel): Promise<FetchStudentsByGroupIdResModel> {
    const { classId, groupId } = params;
    return this.get(`${classId}/groups/${groupId}/students`);
  }
  getClassLessonSetting(classId: string, groupId: string): Promise<ClassLessonPlanDto> {
    return this.get(`content/${classId}/groupId/${groupId}/lesson-setting`);
  }

  updateUnitLessonNumber(classId: string, unit: number, lesson: number, teacherId: string): Promise<void> {
    return this.create(`schools/${classId}/unit`, { unit, lessonNumber: lesson, updateBy: teacherId });
  }

  getRegionAccessible(): Promise<ResourceModel[]> {
    const url = `connect/accessible/regions`;
    return this.get(url);
  }
  getSchoolAccessible(regionId = ""): Promise<ResourceModel[]> {
    const url = `connect/accessible/schools`;
    return this.get(url, { regionId, __gl_region__: regionId || "" });
  }
  getCampusAccessible(schoolId = ""): Promise<ResourceModel[]> {
    const url = `connect/accessible/campuses`;
    return this.get(url, { schoolId });
  }
}

export const TeacherService = new GLTeacherService();
